import cn from 'classnames';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { TextInput } from '@shared/ui';
import * as st from './styles.module.scss';

interface Props {
  control: any;
  name: string;
  disabled?: boolean;
  error: boolean;
  label: string | undefined;
  tabindex?: number;
  variant: 'outline' | 'online' | undefined;
  placeholder?: string;
  onChange?: () => void;
}

const TextControlled: FC<Props> = ({
  control,
  label,
  error,
  name,
  disabled,
  variant,
  tabindex,
  onChange: onChangeFromProps,
  placeholder = 'Имя',
}) => {
  // console.log('name', name);
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value, onBlur } }) => {
        return (
          <>
            <label
              className={cn(
                variant === 'outline' && st.label_outline,
                variant === 'online' && st.label_online,
                error && st.error
              )}
              htmlFor={name}
            >
              <p>{label}</p>
            </label>
            <div className={cn(st.controller, error && st.error)}>
              <TextInput
                disabled={disabled}
                placeholder={placeholder}
                // country={'ru'}
                value={value}
                onBlur={onBlur}
                onChange={(val) => {
                  onChangeFromProps && onChangeFromProps();
                  onChange(val);
                }}
                // localization={ru}
                // inputClass={cn(st.input, error && st.error)}
                isValid={error}
                // specialLabel=""
                className={cn(st.wrapper, error && st.error)}
              />
            </div>
          </>
        );
      }}
      rules={{
        required: 'Это поле обязательно',
        minLength: { value: 7, message: 'Номер слишком короткий' },
      }}
      control={control}
    />
  );
};

export default TextControlled;
